import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FAQ } from './IFAQAnswer';
import { Link } from '../../components/ui/Link';

const QuestionAnswerSection: React.FC<FAQ> = ({ faqTitle, faqText }) => (
    <section
      className="flex md:max-w-[856px]
    flex-col justify-center gap-[16px] shadow-lg
    px-[16px] sm:px-[30px]
    pt-[16px] pb-[24px] sm:pt-[24px] sm:pb-[40px]
    relative bg-white z-30 rounded-[8px]
  "
    >
      <h1
        className="font-avantgarde font-bold
        text-blue-900 sm:text-[32px] sm:leading-[48px]
        text-[18px] leading-[27px]"
      >
        {faqTitle}
      </h1>
      <p
        className="font-roboto font-normal text-stone-800 text-[14px] sm:text-[18px]
         sm:leading-[29.7px] leading-[23.1px] whitespace-pre-wrap"
      >
        {faqText}
      </p>

      <div className="sm:w-full">
        <Link
          title="Terug naar het overzicht"
          href="/home/faqoverzicht"
          variant="default"
          className="bg-stone-100 border-stone-200 md:text-sm font-bold"
        >
          <FontAwesomeIcon icon={faChevronLeft as IconProp} />
          Terug naar het overzicht
        </Link>
      </div>
    </section>
  );

export default QuestionAnswerSection;
